import React, { useState } from 'react';
import { Package, ChevronRight, Sparkles, X, CheckCircle, Clock, Wrench } from 'lucide-react';
import { MobileLayout } from '../components/MobileLayout';
import { Tabs } from '../components/ui/Tabs';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardContent } from '../components/ui/Card';
export function AbbonamentiPage() {
  const [showStoricoModal, setShowStoricoModal] = useState(false);
  const [activeTab, setActiveTab] = useState<'pulizie' | 'interventi'>('pulizie');
  // Mock data for available cleanings
  const availableCleanings = 13;
  const totalCleanings = 20;
  const progressPercent = availableCleanings / totalCleanings * 100;
  // Mock data for cleaning breakdown
  const cleaningBreakdown = [{
    count: 3,
    expiryDate: '15 Mar 2024'
  }, {
    count: 10,
    expiryDate: '20 Mag 2024'
  }];
  // Mock data for consumption history
  const consumptionHistory = [{
    id: '1',
    date: '10 Gen 2024',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }, {
    id: '2',
    date: '8 Gen 2024',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }, {
    id: '3',
    date: '5 Gen 2024',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }, {
    id: '4',
    date: '2 Gen 2024',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }, {
    id: '5',
    date: '28 Dic 2023',
    property: 'Villa Sunset',
    type: 'Ordinaria'
  }];
  // Mock data for extraordinary interventions history
  const extraordinaryHistory = [{
    id: '1',
    icon: '⚡',
    title: 'Lampadina bagno',
    date: '15 Gen 2024',
    price: '€35',
    status: 'Completato'
  }, {
    id: '2',
    icon: '🧹',
    title: 'Deep cleaning',
    date: '10 Gen 2024',
    price: '€120',
    status: 'Completato'
  }, {
    id: '3',
    icon: '🔧',
    title: 'Riparazione rubinetto',
    date: '5 Gen 2024',
    price: '€85',
    status: 'Completato'
  }];
  // Cleaning package options
  const cleaningPackages = [{
    id: '1',
    cleanings: 10,
    price: 299,
    validity: '3 mesi',
    discount: null,
    popular: false
  }, {
    id: '2',
    cleanings: 15,
    price: 399,
    validity: '4 mesi',
    discount: '10%',
    popular: true
  }, {
    id: '3',
    cleanings: 30,
    price: 699,
    validity: '6 mesi',
    discount: '20%',
    popular: false
  }];
  // Intervention package options
  const interventionPackages = [{
    id: '1',
    name: 'Base',
    hours: 5,
    price: 149,
    validity: '3 mesi',
    discount: null,
    popular: false
  }, {
    id: '2',
    name: 'Standard',
    hours: 10,
    price: 279,
    validity: '6 mesi',
    discount: '10%',
    popular: true
  }, {
    id: '3',
    name: 'Premium',
    hours: 20,
    price: 499,
    validity: '12 mesi',
    discount: '15%',
    popular: false
  }];
  return <MobileLayout data-id="element-1177">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-1178">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-1179">
          Pacchetti pulizie
        </h1>
      </div>

      {/* Active Package Card */}
      <Card className="w-full lg:w-1/2 shadow-sm mb-6" data-id="element-1180">
        <CardHeader action={<span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded-full" data-id="element-1182">
              Attivo
            </span>} data-id="element-1181">
          <div className="flex items-center gap-2" data-id="element-1183">
            <Package size={18} className="text-coral" data-id="element-1184" />
            <h2 className="text-sm font-medium text-navy" data-id="element-1185">Pacchetto Attivo</h2>
          </div>
        </CardHeader>
        <CardContent data-id="element-1186">
          {/* Usage this month - New layout */}
          <div className="mb-4" data-id="element-1187">
            <div className="flex items-center justify-between mb-2" data-id="element-1188">
              <span className="text-sm text-gray-600" data-id="element-1189">
                Utilizzo questo mese
              </span>
              <span className="text-sm font-semibold text-navy" data-id="element-1190">
                {totalCleanings - availableCleanings} / {totalCleanings}
              </span>
            </div>
            {/* Progress bar */}
            <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1191">
              <div className="bg-coral h-2 rounded-full transition-all duration-300" style={{
              width: `${(totalCleanings - availableCleanings) / totalCleanings * 100}%`
            }} data-id="element-1192"></div>
            </div>
          </div>

          {/* CTA to view details */}
          <button onClick={() => setShowStoricoModal(true)} className="w-full flex items-center justify-between py-3 px-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors text-sm text-gray-600 hover:text-navy" data-id="element-1193">
            <span data-id="element-1194">Vedi dettaglio interventi</span>
            <ChevronRight size={18} className="text-gray-400" data-id="element-1195" />
          </button>
        </CardContent>
      </Card>

      {/* Tab Navigation for Packages */}
      <Tabs className="mb-6" scrollable value={activeTab} onValueChange={id => setActiveTab(id as 'pulizie' | 'interventi')} items={[{
      id: 'pulizie',
      label: 'Pulizie',
      icon: <Package size={16} data-id="element-1197" />
    }, {
      id: 'interventi',
      label: 'Interventi',
      icon: <Wrench size={16} data-id="element-1198" />
    }]} data-id="element-1196" />

      {/* Pulizie Tab */}
      {activeTab === 'pulizie' && <div className="space-y-4" data-id="element-1199">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-2" data-id="element-1200">
            Aggiungi pulizie
          </div>

          {cleaningPackages.map(pkg => <div key={pkg.id} className={`bg-white rounded-xl shadow-sm p-4 relative transition-all ${pkg.popular ? 'border-2 border-coral' : 'border border-border'}`} data-id="element-1201">
              {pkg.popular && <span className="absolute -top-2.5 left-4 bg-coral text-white text-xs px-2 py-0.5 rounded-full font-medium flex items-center gap-1" data-id="element-1202">
                  <Sparkles size={10} data-id="element-1203" />
                  Più scelto
                </span>}

              <div className="flex items-center justify-between" data-id="element-1204">
                <div className="flex-1" data-id="element-1205">
                  <div className="text-sm font-semibold text-navy mb-0.5" data-id="element-1206">
                    +{pkg.cleanings} pulizie
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-1207">
                    Validità {pkg.validity}
                  </div>
                </div>

                <div className="flex items-center gap-3" data-id="element-1208">
                  <div className="text-right" data-id="element-1209">
                    <div className="text-sm font-semibold text-coral" data-id="element-1210">
                      €{pkg.price}
                    </div>
                    {pkg.discount && <div className="text-xs text-coral" data-id="element-1211">-{pkg.discount}</div>}
                  </div>
                  <Button variant={pkg.popular ? 'primary' : 'outline'} size="md" data-id="element-1212">
                    Acquista
                  </Button>
                </div>
              </div>
            </div>)}
        </div>}

      {/* Interventi Tab */}
      {activeTab === 'interventi' && <div className="space-y-4" data-id="element-1213">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-2" data-id="element-1214">
            Pacchetti ore interventi
          </div>

          {interventionPackages.map(pkg => <div key={pkg.id} className={`bg-white rounded-xl shadow-sm p-4 relative transition-all ${pkg.popular ? 'border-2 border-coral' : 'border border-border'}`} data-id="element-1215">
              {pkg.popular && <span className="absolute -top-2.5 left-4 bg-coral text-white text-xs px-2 py-0.5 rounded-full font-medium flex items-center gap-1" data-id="element-1216">
                  <Sparkles size={10} data-id="element-1217" />
                  Più scelto
                </span>}

              <div className="flex items-center justify-between" data-id="element-1218">
                <div className="flex-1" data-id="element-1219">
                  <div className="text-sm font-semibold text-navy mb-0.5" data-id="element-1220">
                    {pkg.name} - {pkg.hours} ore
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-1221">
                    Validità {pkg.validity}
                  </div>
                </div>

                <div className="flex items-center gap-3" data-id="element-1222">
                  <div className="text-right" data-id="element-1223">
                    <div className="text-sm font-semibold text-coral" data-id="element-1224">
                      €{pkg.price}
                    </div>
                    {pkg.discount && <div className="text-xs text-coral" data-id="element-1225">-{pkg.discount}</div>}
                  </div>
                  <Button variant={pkg.popular ? 'primary' : 'outline'} size="md" data-id="element-1226">
                    Acquista
                  </Button>
                </div>
              </div>
            </div>)}

          <p className="text-xs text-gray-500 mt-4 p-3 bg-gray-50 rounded-lg" data-id="element-1227">
            I pacchetti interventi includono manutenzione, riparazioni e servizi
            extra. Le ore vengono scalate in base alla durata dell'intervento.
          </p>
        </div>}

      {/* Storico Modal */}
      {showStoricoModal && <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={() => setShowStoricoModal(false)} data-id="element-1228">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-lg max-h-[80vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-1229">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-1230">
              <h2 className="text-lg font-bold text-navy" data-id="element-1231">
                Storico Interventi
              </h2>
              <button onClick={() => setShowStoricoModal(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1232">
                <X size={20} className="text-gray-500" data-id="element-1233" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex-1 overflow-y-auto p-4 space-y-6" data-id="element-1234">
              {/* Scadenze */}
              <div data-id="element-1235">
                <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-3" data-id="element-1236">
                  Scadenze
                </div>
                <div className="space-y-2" data-id="element-1237">
                  {cleaningBreakdown.map((item, index) => <div key={index} className="flex items-center justify-between text-sm p-3 bg-gray-50 rounded-lg" data-id="element-1238">
                      <div className="flex items-center gap-2 text-gray-600" data-id="element-1239">
                        <Clock size={14} className="text-gray-400" data-id="element-1240" />
                        <span data-id="element-1241">{item.count} pulizie</span>
                      </div>
                      <span className="text-gray-400" data-id="element-1242">
                        scadono il {item.expiryDate}
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Storico Pulizie */}
              <div data-id="element-1243">
                <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-3" data-id="element-1244">
                  Storico Pulizie
                </div>
                <div className="space-y-2" data-id="element-1245">
                  {consumptionHistory.map(item => <div key={item.id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0" data-id="element-1246">
                      <div className="flex items-center gap-3" data-id="element-1247">
                        <div className="w-8 h-8 rounded-full bg-teal-deep/10 flex items-center justify-center" data-id="element-1248">
                          <CheckCircle size={14} className="text-teal-deep" data-id="element-1249" />
                        </div>
                        <div data-id="element-1250">
                          <div className="text-sm font-medium text-navy" data-id="element-1251">
                            {item.property}
                          </div>
                          <div className="text-xs text-gray-400" data-id="element-1252">
                            {item.type}
                          </div>
                        </div>
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-1253">{item.date}</div>
                    </div>)}
                </div>
              </div>

              {/* Interventi Straordinari */}
              <div data-id="element-1254">
                <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-3" data-id="element-1255">
                  Interventi Straordinari
                </div>
                <div className="space-y-2" data-id="element-1256">
                  {extraordinaryHistory.map(item => <div key={item.id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0" data-id="element-1257">
                      <div className="flex items-center gap-3" data-id="element-1258">
                        <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center text-base" data-id="element-1259">
                          {item.icon}
                        </div>
                        <div data-id="element-1260">
                          <div className="text-sm font-medium text-navy" data-id="element-1261">
                            {item.title}
                          </div>
                          <div className="text-xs text-gray-400" data-id="element-1262">
                            {item.date}
                          </div>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-1263">
                        <div className="text-sm font-semibold text-navy" data-id="element-1264">
                          {item.price}
                        </div>
                        <div className="text-xs text-green-600" data-id="element-1265">
                          {item.status}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>}
    </MobileLayout>;
}